export default {
  remediationResult: [],
  hostsGroups: [],
  allOs: [],
  autoRemediateGroups: [],
  ajaxResponse: {},
  customRemediationsForEntity: [],
  playBookActionTemplates: [],
  hostRemediateDetails: {}
};
